module.exports = __webpack_public_path__ + "img/leftright.9444f26e.svg";